import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bccb9d86&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bccb9d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccb9d86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bccb9d86')) {
      api.createRecord('bccb9d86', component.options)
    } else {
      api.reload('bccb9d86', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bccb9d86&scoped=true&", function () {
      api.rerender('bccb9d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/stat/otwoo0201/index.vue"
export default component.exports